import Grid from "@material-ui/core/Grid";
import * as React from "react";

import Container from "../Container";
import CustomerGroupFilter from "./CustomerGroupFilter";
import CustomerGroupList from "./CustomerGroupList";
import CustomerGroupResult from "./CustomerGroupResult";

class CustomerGroups extends React.Component {
  public render() {
    return (
      <Container>
        <Grid container={true} spacing={2}>
          <Grid item={true} xs={12}>
            <CustomerGroupList />
          </Grid>
          <Grid item={true} xs={12}>
            <CustomerGroupFilter />
          </Grid>
          <Grid item={true} xs={12}>
            <CustomerGroupResult />
          </Grid>
        </Grid>
      </Container>
    );
  }
}

export default CustomerGroups;



// WEBPACK FOOTER //
// ./src/components/CustomerGroups/CustomerGroups.tsx